export default __webpack_public_path__ + "static/pilldrill-9fb1040366dabfedf572256e1391070c.svg";